import React from 'react';
import DialogContent from '@material-ui/core/DialogContent';
import CreateGroup from 'pages/groups/CreateGroup';
import EditGroup from 'pages/groups/EditGroup';
import {
  Container,
  DialogTitle,
} from 'styles/pages/edit-products/editProductDialog';
import { StyledDialog } from 'pages/groups/style';

const GroupDialog = ({
  open,
  setModal,
  createGroup,
  group,
  groups,
  onShift,
  onProductsSave,
  syncGroupProducts,
}) => {
  const create = !group?.name;
  const handleClose = () => setModal(false);

  return (
    <StyledDialog
      open={open}
      onClose={handleClose}
      maxWidth={create ? 'sm' : 'xl'}
      style={{ width: '100%' }}>
      <Container>
        <DialogTitle>
          {create ? 'Create Group' : `Edit Group - ${group?.name}`}&nbsp;
        </DialogTitle>
        <DialogContent>
          {create ? (
            <CreateGroup createGroup={createGroup} />
          ) : (
            <EditGroup
              groupName={group?.name}
              groups={groups}
              onShift={onShift}
              onProductsSave={onProductsSave}
              syncGroupProducts={syncGroupProducts}
            />
          )}
        </DialogContent>
      </Container>
    </StyledDialog>
  );
};

export default GroupDialog;
